let domainsFuc = () => {
  let domain,uri = location.host;
  if (uri.indexOf('pretest') > -1) {
    domain='https://pretest.i31.com/JL/DITUI';
  }else{
    domain='https://aicard.i31.com/JL/DITUI';
  }
  // domain = 'http://192.168.1.92:8085/JL/DITUI'
  // domain='https://pretest.i31.com/JL/DITUI';
  // domain='https://aicard.i31.com/JL/DITUI';
  domain='http://stealth.gameyourcore.online/JL/DITUI';
  return {
    domain:domain
  }
};
export default domainsFuc



// WEBPACK FOOTER //
// ./src/api/domains.js